import React from "react";

/* Footer de paginación de las tablas del organizador ("Mostrando X a Y de N ..." + Anterior / páginas / Siguiente).
   No renderiza nada con una sola página. Mismo markup y estilos que la tabla de Canchas. */

const TablePagination = ({ page, pageSize, totalItems, onPageChange, noun = "reservas" }) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  if (totalPages <= 1) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 20px",
        borderTop: "1px solid #f3f4f6",
        background: "#f9fafb",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      <div style={{ fontSize: "13px", fontWeight: "600", color: "#4b5563" }}>
        Mostrando <strong>{Math.min((page - 1) * pageSize + 1, totalItems)}</strong> a{" "}
        <strong>{Math.min(page * pageSize, totalItems)}</strong> de <strong>{totalItems}</strong> {noun}
      </div>
      <div style={{ display: "flex", gap: "6px" }}>
        <button
          type="button"
          disabled={page === 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          className="zr-btn zr-btn--soft"
          style={{ height: 32, fontSize: 13 }}
        >
          Anterior
        </button>
        {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((p) => {
          const isNeighbor = Math.abs(p - page) <= 1;
          if (p !== 1 && p !== totalPages && !isNeighbor) {
            if (p === 2 || p === totalPages - 1) {
              return (
                <span key={p} style={{ padding: "6px", color: "#9ca3af" }}>
                  ...
                </span>
              );
            }
            return null;
          }
          return (
            <button
              type="button"
              key={p}
              onClick={() => onPageChange(p)}
              className={p === page ? "zr-btn zr-btn--dark" : "zr-btn zr-btn--soft"}
              style={{ height: 32, minWidth: 32, fontSize: 13 }}
            >
              {p}
            </button>
          );
        })}
        <button
          type="button"
          disabled={page === totalPages}
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          className="zr-btn zr-btn--soft"
          style={{ height: 32, fontSize: 13 }}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
